/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Tooltip_CalculatedInputs */



/**
* | output |
* | --- |
* | "Last calculated on<br />{date}" |
*
* @param {Tooltip_CalculatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const tooltip_calculated = /** @type {((inputs: Tooltip_CalculatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tooltip_CalculatedInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`Last calculated on<br />${i?.date}`)
});